<!--添加报告（第二步） - 测评报告 -->
<template>
  <a-spin :spinning="boxSpinning" style="min-height: 50px">
    <div>
      <div class="table">
        <a-table v-show="collapseList.length" :columns="columns" :pagination="false" :expandedRowKeys="expandedRowKeys" rowKey="id" @expand="expandedChange" :data-source="collapseList">
          <div slot="courseName" slot-scope="text">{{ text.courseName }}{{ text.period ? ' - ' + text.period : '' }}</div>
          <div slot="progress" slot-scope="text, record">
            <a-progress :percent="text" size="small" />
          </div>
          <div slot="action" class="action" slot-scope="text, record">
            <a-popconfirm title="确定删除？" @confirm="del(text)">
              <a href="javaScript:;" class="red">
                <a-icon type="delete" />
                删除
              </a>
            </a-popconfirm>
          </div>
          <a-table slot="expandedRowRender" slot-scope="text" rowKey="contentId" :columns="innerColumns" :data-source="text.childTableData" :loading="text.loading" :pagination="false">
            <div slot="abilityType" slot-scope="text">
              <div v-for="item in text.abilityDetails" class="lattice-item">{{ item.abilityTypeName }}</div>
            </div>
            <div slot="firstAbility" slot-scope="text">
              <div v-for="item in text.abilityDetails" class="lattice-item">{{ item.firstAbilityName }}</div>
            </div>
            <div slot="secondAbility" slot-scope="text">
              <div v-for="item in text.abilityDetails" class="lattice-item">{{ item.secondAbilityName }}</div>
            </div>
            <div slot="scoreSwitch" slot-scope="text">
              <div v-for="item in text.abilityDetails" class="lattice-item">
                <a-switch @change="changeScoreSwitch" v-model="item.scoreSwitch" checked-children="开" un-checked-children="关" />
              </div>
            </div>
          </a-table>
        </a-table>
      </div>
      <p v-if="!IsDetails" style="text-align: center; margin-top: 35px">
        <a-button type="primary" @click="addCourse.visible = true">添加课程</a-button>
      </p>
    </div>

    <!--添加课程-->
    <a-modal v-model="addCourse.visible" :centered="true" :destroyOnClose="true" :title="addCourse.title" :confirm-loading="addCourse.confirmLoading" @ok="addCourseModelFormOk" width="1200px">
      <StepsSecondAddCourse ref="addCourse" :collapseList="collapseList" />
    </a-modal>
  </a-spin>
</template>

<script>
import StepsSecondAddCourse from '../components/StepsSecondAddCourse'
import StepsSecondAddStudents from '../components/StepsSecondAddStudents'
import $Bus from '@/pages/projectImpl/js/eventBus'

const columns = [
  {
    title: '测评名称',
    dataIndex: 'organizationCourseName',
    ellipsis: true,
  },
  {
    title: '测评进度',
    dataIndex: 'progress',
    scopedSlots: { customRender: 'progress' },
    align: 'center',
  },
  {
    title: '添加时间',
    dataIndex: 'createTime',
    align: 'center',
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
    align: 'center',
  },
]

const innerColumns = [
  { title: '课时名称', dataIndex: 'childCourseName' },
  { title: '任务名称', dataIndex: 'contentName' },
  { title: '能力类型', scopedSlots: { customRender: 'abilityType' }, className: 'lattice' },
  { title: '一级能力', scopedSlots: { customRender: 'firstAbility' }, className: 'lattice' },
  { title: '二级能力', scopedSlots: { customRender: 'secondAbility' }, className: 'lattice' },
  { title: '算分开关', scopedSlots: { customRender: 'scoreSwitch' }, className: 'lattice' },
]

export default {
  name: 'AssessReport',
  components: { StepsSecondAddCourse, StepsSecondAddStudents },
  props: {
    groupReportContrastSampleId: '',
    IsDetails: false,
  },
  data() {
    return {
      boxSpinning: false,
      //如果有这个id的话，说明此报告是从智慧云那边生成的
      projectCourseConfigId: this.$store.getters['organization/getReportInfo'].projectCourseConfigId,
      //课程列表
      collapseList: [],
      expandedRowKeys: [],
      columns,
      innerColumns,
      //当前报告信息
      reportInfo: this.$store.getters['organization/getReportInfo'],
      // 添加课程弹框相关
      addCourse: {
        visible: false,
        confirmLoading: false,
        title: '添加课程',
      },
      // 配置用户弹框相关
      userConfig: {
        visible: false,
        confirmLoading: false,
        nowCourseInfo: {},
      },
    }
  },
  mounted() {
    this.getCourseList()
  },
  methods: {
    changeScoreSwitch(e) {},
    // 已添加课程列表
    getCourseList() {
      let params = {
        pageSize: 9999,
        pageIndex: 1,
        combinationReportId: this.reportInfo.id,
        organizationId: this.reportInfo.organizationId,
      }
      this.boxSpinning = true
      this.$http.GroupReport.addCourseList(params).then((res) => {
        this.expandedRowKeys = []
        this.boxSpinning = false
        this.collapseList = res.data.items.map((m) => ({ childTableData: [], loading: false, ...m }))
        let arr = []
        this.collapseList.forEach((v) => {
          arr.push(v.organizationCourseId)
        })
        this.$store.commit('organization/setReportCourse', arr)
      })
    },
    expandedChange(expanded, record) {
      if (expanded) {
        this.expandedRowKeys.push(record.id)
        const params = {
          combinationReportId: this.reportInfo.id,
          organizationCourseId: record.organizationCourseId,
        }
        record.loading = true
        this.$http.GroupReport.getCourseAbilityConfigs(params).then((res) => {
          record.childTableData = res.data
        }).finally(() => {
          record.loading = false
        })
      } else {
        this.expandedRowKeys.splice(this.expandedRowKeys.indexOf(record.id), 1)
      }
    },
    // 删除课程
    del(val) {
      const form = new FormData()
      form.append('id', val.id)
      this.$message.destroy()
      this.$http.GroupReport.deleteCourse(form).then((res) => {
        this.getCourseList()
        this.$message.success(res.message)
      })
    },
    //添加课程弹框确认
    addCourseModelFormOk() {
      // let arr = this.$refs.addCourse.$data.tableSelected.selectedRows
      let arr = this.$refs.addCourse.$data.tableSelected.selectedRowKeys
      console.log(arr)
      let formData = new FormData()
      formData.append('reportConfigId', this.reportInfo.id)
      arr.forEach((item, index) => {
        for (let key in JSON.parse(item)) {
          if (key == 'organizationCourseId') {
            formData.append(`projectCourseConfigIds[${index}]`, JSON.parse(item)[key])
          }
        }
      })
      this.addCourse.confirmLoading = true
      this.$http.GroupReport.addCourse(formData).then((res) => {
        this.addCourse.visible = false
        this.getCourseList()
        this.$message.success(res.message)
      }).finally(() => {
        this.addCourse.confirmLoading = false
      })
    },
  },
}
</script>

<style scoped lang="less">
.table /deep/ .lattice {
  padding: 0;

  .lattice-item {
    padding: 16px;
  }
}
</style>
